import { z } from 'zod';

export const Overview = z.object({
  // 通関許可待ち
  import_delaration: z.object({
    zero_days_before_pickup: z.number(), // 集荷日当日
    one_days_before_pickup: z.number(), // 集荷日前日
    two_days_before_pickup: z.number(), // 集荷日前々日
  }),
  // ドライバー情報待ち
  driver_info: z.object({
    zero_days_before_pickup: z.number(), // 集荷日当日
  }),
  do: z.number(), // D/O未取得, ETA >= 今日
  move_out: z.number(), // 搬出未取得, ETA >= 今日
  customs_request: z.number(), // 通関依頼未, ETA <= 今日
  customs_instruction: z.number(), // 通関指示未, ETD <= 今日
  delivery_request: z.number(), // 配車依頼未, ETA <= 今日
  delivery_instruction: z.number(), // 配車指示未, ETD <= 今日
});

export type Overview = z.infer<typeof Overview>;
